import IntroNewPartial from './IntroNewPartial';
import DoGuide from '../Tabs/DoGuide';
import ProgressiveIntro from './ProgressiveIntro';


function App(props) {

  var history = props.history;
  var setIsShowingPrevious = props.setIsShowingPrevious;
  var selectNew = props.selectNew;
  var width = props.width;
  var height = props.height;
  var addToExtraScreen = props.addToExtraScreen;
  var scrollAmt = props.scrollAmt;
  var clickBack = props.clickBack;
  var chains = props.chains;
  var logInState = props.logInState;
  var isShowingPrevious = props.isShowingPrevious;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var palette = props.palette;
  var changeTab = props.changeTab;

  var toggleLine;

  if (logInState){
    if (history && history !== 'loading' && history.length > 0){
      function clickPrevious(e){
        setIsShowingPrevious('previous');
      }
      if (!isShowingPrevious){
        toggleLine = <p className='lead mb-0' onClick={clickPrevious} style={{cursor:'pointer'}}><u>See Previous dApps</u><br/></p>
//
      }else{
        toggleLine = <p className='lead mb-0' onClick={clickBack} style={{cursor:'pointer'}}><u>Back</u><br/></p>
      }
  //
    }else if (history === 'loading'){
      toggleLine = <p className='lead mb-0' >Loading...<br/></p>
  //
    }
  }else{
    function clickLogIn(e){
      addToExtraScreen({t:'signIn'});
    }

    toggleLine =  <p className='lead mb-0' onClick={clickLogIn} style={{cursor:'pointer', textDecoration:'underline'}}>Sign in to view previous work</p>

  }
//
  var details;

  if (!isShowingPrevious){
    details = <ProgressiveIntro selectNew={selectNew} setIsShowingPrevious={setIsShowingPrevious} itemCategories={[]} itemType='dapp'/>      
  }else{
    details = <IntroNewPartial chains={chains} width={width} height={height} addToExtraScreen={addToExtraScreen} scrollAmt={scrollAmt} isShowingPrevious={isShowingPrevious} colorCombo={colorCombo} setColorCombo={setColorCombo} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} palette={palette} changeTab={changeTab}/>

  }

  return <div className='container py-5' >
          <div className='row' >
            <div className='col-lg-8 mx-auto text-center'>
              <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'guidedIntro'}} />
              <h1 className='display-4' >Create a new dApp</h1>
              {toggleLine}
            </div>
          </div>
          <br/>
          {details}
        </div>
//
}

export default App;
